<div class="text-xs opacity-50">{{ label }}</div>
<div><ng-content /></div>
